import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import Meta from '../components/Meta';
import './LegalPages.css';

function Datenschutz() {
  const { t } = useTranslation();

  // Helper to safely get list from i18n
  const getList = (key) => {
    const list = t(key, { returnObjects: true });
    return Array.isArray(list) ? list : [];
  };

  return (
    <div className="legal-page-wrapper">
      <Meta
        title={`${t('legal.datenschutz.title')} | Vorpoint`}
        description={t('legal.datenschutz.subtitle')}
      />
      <section className="legal-hero">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <div className="legal-hero-badge">{t('legal.datenschutz.badge')}</div>
          <h1>{t('legal.datenschutz.title')}</h1>
          <p>{t('legal.datenschutz.subtitle')}</p>
        </motion.div>
      </section>

      <motion.div
        className="legal-content"
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.2 }}
      >
        {/* 1. Verantwortlicher */}
        <div className="legal-card">
          <div className="legal-card-icon">👤</div>
          <h2>{t('legal.datenschutz.section_1_title')}</h2>
          <p>
            <strong>Ahmed Tahhan (Vorpoint)</strong><br />
            Gorkistraße 84<br />
            04347 Leipzig<br />
            Deutschland<br /><br />
            E-Mail: <a href="mailto:info@vorpoint.de">info@vorpoint.de</a><br />
            Telefon: <a href="tel:+491778663796">+49-1778663796</a>
          </p>
        </div>

        {/* 2. Verarbeitete Daten */}
        <div className="legal-card">
          <div className="legal-card-icon">📋</div>
          <h2>{t('legal.datenschutz.section_2_title')}</h2>
          <p>{t('legal.datenschutz.section_2_text')}</p>
          <ul className="legal-list">
            {getList('legal.datenschutz.section_2_list').map((item, idx) => (
              <li key={idx}>{item}</li>
            ))}
          </ul>
        </div>

        {/* 3. Zweck und Rechtsgrundlage */}
        <div className="legal-card">
          <div className="legal-card-icon">⚖️</div>
          <h2>{t('legal.datenschutz.section_3_title')}</h2>
          <ul className="legal-list">
            {getList('legal.datenschutz.section_3_list').map((item, idx) => (
              <li key={idx}>{item}</li>
            ))}
          </ul>
        </div>

        {/* 4. Kontaktformular */}
        <div className="legal-card">
          <div className="legal-card-icon">📩</div>
          <h2>{t('legal.datenschutz.section_4_title')}</h2>
          <p>{t('legal.datenschutz.section_4_text')}</p>
        </div>

        {/* 5. Google Analytics */}
        <div className="legal-card">
          <div className="legal-card-icon">📊</div>
          <h2>{t('legal.datenschutz.section_5_title')}</h2>
          <p>{t('legal.datenschutz.section_5_text_1')}</p>
          <p>
            {t('legal.datenschutz.section_5_text_2')}{' '}
            <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" rel="noopener noreferrer">
              tools.google.com/dlpage/gaoptout
            </a>
          </p>
          <div className="legal-info-box">
            <strong>{t('legal.datenschutz.section_5_cookie_title')}</strong> {t('legal.datenschutz.section_5_cookie_text')}
          </div>
        </div>

        {/* 6. Speicherdauer */}
        <div className="legal-card">
          <div className="legal-card-icon">⏱️</div>
          <h2>{t('legal.datenschutz.section_6_title')}</h2>
          <p>{t('legal.datenschutz.section_6_text')}</p>
          <ul className="legal-list">
            {getList('legal.datenschutz.section_6_list').map((item, idx) => (
              <li key={idx}>{item}</li>
            ))}
          </ul>
        </div>

        {/* 7. Ihre Rechte */}
        <div className="legal-card">
          <div className="legal-card-icon">🛡️</div>
          <h2>{t('legal.datenschutz.section_7_title')}</h2>
          <p>{t('legal.datenschutz.section_7_text')}</p>
          <ul className="legal-list">
            {getList('legal.datenschutz.section_7_list').map((item, idx) => (
              <li key={idx}>{item}</li>
            ))}
          </ul>
          <p>
            {t('legal.datenschutz.section_7_footer')} <a href="mailto:info@vorpoint.de">info@vorpoint.de</a>
          </p>
        </div>

        {/* 8. Beschwerderecht */}
        <div className="legal-card">
          <div className="legal-card-icon">🏛️</div>
          <h2>{t('legal.datenschutz.section_8_title')}</h2>
          <p>{t('legal.datenschutz.section_8_text')}</p>
          <p>
            <strong>Sächsischer Datenschutzbeauftragter</strong><br />
            Devrientstraße 5<br />
            01067 Dresden<br />
            <a href="https://www.saechsdsb.de" target="_blank" rel="noopener noreferrer">www.saechsdsb.de</a>
          </p>
        </div>

        {/* 9. Datensicherheit */}
        <div className="legal-card">
          <div className="legal-card-icon">🔐</div>
          <h2>{t('legal.datenschutz.section_9_title')}</h2>
          <p>{t('legal.datenschutz.section_9_text')}</p>
        </div>

        {/* Stand */}
        <div className="legal-update-notice">
          <p>{t('legal.datenschutz.status')}</p>
        </div>
      </motion.div>
    </div>
  );
}

export default Datenschutz;